<template>
  <div>
    <ValidationProvider slim rules="required" v-slot="state">
      <p class="lib__text-center">{{ $t('e-mobility.electricity-installation-form.explanationForm') }}</p>
      <div :class="validationState(state)" class="lib__field">
        <div class="lib__tiles">
          <TileRadio item="mechanical-meter"
            :label="$t('e-mobility.electricity-installation-form.meterType.mechanicalMeter')"
            data-cy="tile-mechanical-meter" group="meter" v-model="value.meterType"></TileRadio>
          <TileRadio item="smart-meter" :label="$t('e-mobility.electricity-installation-form.meterType.smartMeter')"
            data-cy="tile-smart-meter" group="meter" v-model="value.meterType"></TileRadio>
        </div>
        <error-message :error="state.errors[0]"></error-message>
      </div>
    </ValidationProvider>
    <ValidationProvider v-if="value.meterType" slim rules="required" v-slot="state">
      <div :class="validationState(state)" class="lib__field">
        <header class="lib__form__main__header">
          <h2 class="lib__h2">{{ $t('e-mobility.electricity-installation-form.electricityPowerSupplyTypeTitle') }}
            <div v-if="isMechanicalMeter" class="lib__tooltips">
              <span @click="onElectricityPowerSupplyTypeModalClick">
                <i class="fas fa-info-circle lib__clickable-tooltips"></i>
              </span>
            </div>
          </h2>
          <MyORESRedirectionLink v-if="!isMechanicalMeter" />
        </header>
        <div class="lib__tiles lib__tiles--grid-3">
          <TileRadio item="monophase" :insideTooltip="isMechanicalMeter" @tooltip-click="onMonoModalClick"
            :label="$t('meter.phase.single')"
            :description="$t('e-mobility.electricity-installation-form.meterPowerDescription.mono')"
            data-cy="tile-monophase" group="electricityPowerSupplyTypeTile" v-model="value.electricityPowerSupplyType">
            <template v-slot:picture>
              <img class="meter-picto" :src="monoPhaseIcon" alt="monophase-icon">
            </template>
          </TileRadio>
          <TileRadio item="triphase" :insideTooltip="isMechanicalMeter" @tooltip-click="onThreeModalClick"
            :label="$t('meter.phase.three')"
            :description="$t('e-mobility.electricity-installation-form.meterPowerDescription.three')"
            data-cy="tile-triphase" group="electricityPowerSupplyTypeTile" v-model="value.electricityPowerSupplyType">
            <template v-slot:picture>
              <img class="meter-picto" :src="triPhaseIcon" alt="triphase-icon">
            </template>
          </TileRadio>
          <TileRadio item="tetraphase" :insideTooltip="isMechanicalMeter" @tooltip-click="onTetraModalClick"
            :label="$t('meter.phase.three')"
            :description="$t('e-mobility.electricity-installation-form.meterPowerDescription.tetra')"
            data-cy="tile-tetraphase" group="electricityPowerSupplyTypeTile" v-model="value.electricityPowerSupplyType">
            <template v-slot:picture>
              <img class="meter-picto" :src="tetraPhaseIcon" alt="tetraphase-icon">
            </template>
          </TileRadio>
        </div>
        <error-message :error="state.errors[0]"></error-message>
      </div>
    </ValidationProvider>
    <div v-if="value.electricityPowerSupplyType">
      <header class="lib__form__main__header">
        <h2 class="lib__h2">{{ $t('e-mobility.electricity-installation-form.powerTitle') }}
          <div v-if="isMechanicalMeter" class="lib__tooltips">
            <span @click="onPowerModalClick">
              <i class="fas fa-info-circle lib__clickable-tooltips"></i>
            </span>
          </div>
        </h2>
        <MyORESRedirectionLink v-if="!isMechanicalMeter" />
      </header>
      <NumberBox :disabled="false" :min="1" :max="100"
        :label="$t('e-mobility.electricity-installation-form.powerLabel')" required v-model="value.power"></NumberBox>
    </div>
    <ModalDialog :closeable="$t('common.close')" :open.sync="isElectricityPowerSupplyTypeModalOpen" size="default">
      <div>
        <p>{{ $t('e-mobility.electricity-installation-form.electricityPowerSupplyTypeModal.part1') }}</p>
        <ul class="lib__list--spaced">
          <li v-html="$t('e-mobility.electricity-installation-form.electricityPowerSupplyTypeModal.part2')"></li>
          <li v-html="$t('e-mobility.electricity-installation-form.electricityPowerSupplyTypeModal.part3')"></li>
        </ul>
      </div>
    </ModalDialog>
    <ModalDialog :closeable="$t('common.close')" :open.sync="isPowerModalOpen" size="default">
      <p v-html="$t('e-mobility.electricity-installation-form.powerModal.part1')"></p>
      <div class="row">
        <div class="col-xs-4 col-sm-2">
          <img :src="require('@/assets/e-mobility/power-meter.png')" alt="power-meter-image">
        </div>
        <div class="col-xs-8 col-sm-10">
          <p v-html="$t('e-mobility.electricity-installation-form.powerModal.part2')"></p>
        </div>
      </div>
    </ModalDialog>
    <ModalDialog :closeable="$t('common.close')" :open.sync="isMonoModalOpen" size="small">
      <p>
        <span v-html="$t('e-mobility.electricity-installation-form.monophaseModal.part1')"></span>
        <img class="lib__icon__align-middle" :src="require('@/assets/e-mobility/icon-mono-branch.svg')"
          alt="mono-meter-branch">
        <span v-html="$t('e-mobility.electricity-installation-form.monophaseModal.part2')"></span>
      </p>
      <div>
        <img v-if="isMechanicalMeter" :src="require('@/assets/e-mobility/budget-mono-meter.png')"
          alt="mono-meter-image">
        <img v-else :src="require('@/assets/e-mobility/smart-mono-meter.png')" alt="smart-mono-meter-image">
      </div>
    </ModalDialog>
    <ModalDialog :closeable="$t('common.close')" :open.sync="isThreeModalOpen" size="small">
      <div v-if="isMechanicalMeter">
        <p>
          <span v-html="$t('e-mobility.electricity-installation-form.mechanicalThreeModal.part1')"></span>
          <img class="lib__icon__align-middle" :src="require('@/assets/e-mobility/icons-three-branch.svg')"
            alt="three-meter-branch">
          <span v-html="$t('e-mobility.electricity-installation-form.mechanicalThreeModal.part2')"></span>
        </p>
        <div>
          <img :src="require('@/assets/e-mobility/three-meter.png')" alt="three-meter-image">
        </div>
      </div>
      <div v-else>
        <p>
          <span v-html="$t('e-mobility.electricity-installation-form.smartMeterThreeModal.part1')"></span>
          <img class="lib__icon__align-middle" :src="require('@/assets/e-mobility/icons-three-branch.svg')"
            alt="three-meter-branch">
          <span v-html="$t('e-mobility.electricity-installation-form.smartMeterThreeModal.part2')"></span>
          <img class="lib__icon__align-middle" :src="require('@/assets/e-mobility/icons-tetra-branch.svg')"
            alt="three-meter-branch">
          <span v-html="$t('e-mobility.electricity-installation-form.smartMeterThreeModal.part3')"></span>
        </p>
        <div>
          <img :src="require('@/assets/e-mobility/smart-three-meter.png')" alt="smart-three-meter-image">
        </div>
        <p v-html="$t('e-mobility.electricity-installation-form.smartMeterThreeModal.part4')"></p>
        <p v-html="$t('e-mobility.electricity-installation-form.smartMeterThreeModal.part5')"></p>
      </div>
    </ModalDialog>
    <ModalDialog :closeable="$t('common.close')" :open.sync="isTetraModalOpen" size="small">
      <div v-if="isMechanicalMeter">
        <p>
          <span v-html="$t('e-mobility.electricity-installation-form.mechanicalTetraModal.part1')"></span>
          <img class="lib__icon__align-middle" :src="require('@/assets/e-mobility/icons-tetra-branch.svg')"
            alt="three-meter-branch">
          <span v-html="$t('e-mobility.electricity-installation-form.mechanicalTetraModal.part2')"></span>
        </p>
        <div>
          <img :src="require('@/assets/e-mobility/tetra-meter.png')" alt="tetra-meter-image">
        </div>
      </div>
      <div v-else>
        <p>
          <span v-html="$t('e-mobility.electricity-installation-form.smartMeterTetraModal.part1')"></span>
          <img class="lib__icon__align-middle" :src="require('@/assets/e-mobility/icons-three-branch.svg')"
            alt="three-meter-branch">
          <span v-html="$t('e-mobility.electricity-installation-form.smartMeterTetraModal.part2')"></span>
          <img class="lib__icon__align-middle" :src="require('@/assets/e-mobility/icons-tetra-branch.svg')"
            alt="tetra-meter-branch">
          <span v-html="$t('e-mobility.electricity-installation-form.smartMeterTetraModal.part3')"></span>
        </p>
        <div>
          <img :src="require('@/assets/e-mobility/smart-tetra-meter.png')" alt="smart-tetra-meter-image">
        </div>
        <p v-html="$t('e-mobility.electricity-installation-form.smartMeterTetraModal.part4')"></p>
        <p v-html="$t('e-mobility.electricity-installation-form.smartMeterTetraModal.part5')"></p>
      </div>
    </ModalDialog>
  </div>
</template>

<script lang="ts">
import { ElectricityInstallation, MeterType } from '@/models'
import { Component, Prop } from 'vue-property-decorator'
import FieldBox from '../../Shared/FieldBox'
import { State } from 'vuex-class'
import MyORESRedirectionLink from './MyORESRedirectionLink.vue'

@Component({
  name: 'electricity-installation',
  components: {
    MyORESRedirectionLink
  }
})
export default class ElectricityInstallationForm extends FieldBox {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly value!: ElectricityInstallation | null
  //#endregion

  //#region [Data]
  @State('requestId', { namespace: 'eMobility' })
  public requestId!: string

  public isElectricityPowerSupplyTypeModalOpen: boolean = false
  public isPowerModalOpen: boolean = false
  public isMonoModalOpen: boolean = false
  public isThreeModalOpen: boolean = false
  public isTetraModalOpen: boolean = false

  public iconCCMono = require("@/assets/e-mobility/Icon-CCMono.svg")
  public iconCEMono = require("@/assets/e-mobility/Icon-CEMono.svg")
  public iconCCTri230 = require("@/assets/e-mobility/Icon-CCTri230.svg")
  public iconCETri230 = require("@/assets/e-mobility/Icon-CETri230.svg")
  public iconCCTri400 = require("@/assets/e-mobility/Icon-CCTri400.svg")
  public iconCETri400 = require("@/assets/e-mobility/Icon-CETri400.svg")
  //#endregion

  //#region [Computed]
  public get isMechanicalMeter() {
    return this.value?.meterType === MeterType.mechanicalMeter
  }

  public get monoPhaseIcon() {
    return this.value?.meterType === MeterType.mechanicalMeter ? this.iconCEMono : this.iconCCMono
  }

  public get triPhaseIcon() {
    return this.value?.meterType === MeterType.mechanicalMeter ? this.iconCETri230 : this.iconCCTri230
  }

  public get tetraPhaseIcon() {
    return this.value?.meterType === MeterType.mechanicalMeter ? this.iconCETri400 : this.iconCCTri400
  }
  //#endregion

  //#region [Method]
  public onElectricityPowerSupplyTypeModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'PowerSupplyType'
    })
    this.isElectricityPowerSupplyTypeModalOpen = !this.isElectricityPowerSupplyTypeModalOpen
  }
  public onPowerModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'Power'
    })
    this.isPowerModalOpen = !this.isPowerModalOpen
  }
  public onMonoModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'MonophaseTile'
    })
    this.isMonoModalOpen = !this.isMonoModalOpen
  }
  public onThreeModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'ThreephaseTile'
    })
    this.isThreeModalOpen = !this.isThreeModalOpen
  }
  public onTetraModalClick(): void {
    this.$appInsights.trackEvent('EMobility_TooltipClick', {
      Segment: 'EMobility',
      WebRef: this.requestId,
      Tooltip: 'TetraphaseTile'
    })
    this.isTetraModalOpen = !this.isTetraModalOpen
  }
  //#endregion
}
</script>

<style scoped>
.meter-picto {
  max-height: 100px;
}
</style>
